<template>
  <div>
    <AppHeader @refreshPage="init" />
    <div class="container">
      <div class="page-header">
        <div class="page-title">{{ $t('activitypage.text24') }}</div>
      </div>
      <mt-navbar v-model="selected">
        <mt-tab-item id="1" clss="up">{{ $t('hotnfts') }}</mt-tab-item>
        <mt-tab-item id="2" clss="up">{{ $t('add.games') }}</mt-tab-item>
      </mt-navbar>
      <!-- tab-container -->
      <mt-tab-container v-model="selected">
        <mt-tab-container-item id="1">
          <div class="list1">
            <div class="item" v-for="(item, index) in hotNfts" :key="index">
              <div class="flexable top" style="position: relative">
                <div
                  class="img2"
                  :style="{
                    backgroundImage:
                      'url(' + $store.state.imgUrl + item.image + ')'
                  }"
                  @click="handleRoute('/babe/hotnft', item)"></div>
                <div class="activity-info">
                  <div class="name" @click="handleRoute('/babe/hotnft', item)">
                    {{ item.nft_name }}
                  </div>
                  <div class="price2">{{ item.price }}</div>
                  <div class="share" @click="handleShare('nft', item)">
                    <span>{{ $t('share') }}</span>
                  </div>
                </div>
              </div>
              <div class="total-box flexable">
                <div class="total">
                  <b>{{ item.payment }}</b
                  ><br />
                  {{ $t('payment') }}
                </div>
                <div class="total">
                  <b>{{ item.participants }}</b
                  ><br />
                  {{ $t('participants') }}
                </div>
                <div class="total">
                  <b>{{ item.commission * 100 }}%</b><br />
                  {{ $t('commission') }}
                </div>
                <div class="total">
                  <b>{{ item.income }}</b
                  ><br />
                  {{ $t('income') }}
                </div>
              </div>
            </div>
          </div>
        </mt-tab-container-item>
        <mt-tab-container-item id="2">
          <GamesBox ref="gamesbox" from="babe" :postGames="postBabeGames" />
        </mt-tab-container-item>
      </mt-tab-container>
    </div>
    <mt-popup
      v-model="popupVisible"
      position="bottom"
      :closeOnClickModal="false">
      <SharePop
        :sharePath="sharePath"
        @cancel="
          () => {
            this.popupVisible = false
          }
        " />
      <div
        class="pop-close"
        @click="
          () => {
            this.popupVisible = false
          }
        "></div>
    </mt-popup>
  </div>
</template>
<script>
import { postBabeGames, postBabeNftHots } from '@/api/babe'
import GamesBox from '@/components/GamesBox.vue'
import SharePop from '@/components/SharePop.vue'

export default {
  name: 'BabeActivity',
  components: {
    SharePop,
    GamesBox
  },
  data() {
    return {
      postBabeGames,
      selected: '1',
      hotNfts: [],
      activities: null,
      popupVisible: false,
      sharePath: ''
    }
  },
  watch: {
    popupVisible: {
      handler(n) {
        this.$stopScroll(n)
      },
      deep: true
    },
    '$i18n.locale'() {
      this.init()
    }
  },
  mounted() {
    this.init()
  },
  beforeRouteLeave(to, from, next) {
    if (
      to.name !== 'BabeHotNft' &&
      to.name !== 'BabeActList' &&
      to.name !== 'BabeActDetail' &&
      to.name !== 'BabeQuizDetail'
    ) {
      this.$store.commit('SET_KEEP_ALIVE', [])
    }
    next()
  },
  methods: {
    init() {
      this.$refs.gamesbox.init()
      postBabeNftHots().then((res) => {
        this.hotNfts = res.data
      })
    },
    handleRoute(path, item) {
      if (item) {
        this.$router.push({ path: path, query: { rec_code: item.rec_code } })
      } else {
        this.$router.push({ path: path })
      }
    },
    handleShare(type, item) {
      if (type === 'nft') {
        this.sharePath =
          this.$store.state.userPath +
          '/user/nftdetail?inviteCode=' +
          this.$store.state.user_info.rec_code +
          '&inviteNft=' +
          item.rec_code +
          '&rec_code=' +
          item.rec_code
      } else if (type === 'act') {
        this.sharePath =
          this.$store.state.userPath +
          '/user/activity?inviteCode=' +
          this.$store.state.user_info.rec_code +
          '&inviteAct=' +
          item.rec_code +
          '&rec_code=' +
          item.rec_code
      }
      this.popType = 'share'
      this.popupVisible = true
    }
  }
}
</script>
<style scoped lang="scss">
.list1 .item .total-box {
  margin-top: 0.2rem;
}
</style>



// WEBPACK FOOTER //
// src/views/babe/activity.vue